// OPS Occult Library — comparative visual archive renderer.
// Image-first museum treatment for entries carrying a visualSources array.
(()=>{
  const esc=(value)=>String(value??'').replace(/[&<>'"]/g,(c)=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const key=(value)=>String(value||'').trim().toLowerCase();

  const installStyles=()=>{
    if(document.getElementById('ops-visual-archive-styles')) return;
    const style=document.createElement('style');
    style.id='ops-visual-archive-styles';
    style.textContent=`
      .ops-library__article--editorial.has-visual-archive .ops-library__entry-hero .ops-library__article-art{display:none}
      .ops-library__article--editorial.has-visual-archive .ops-library__entry-hero{grid-template-columns:1fr;min-height:auto;padding-bottom:.7rem}
      .ops-library__visual-archive{margin:.15rem 0 2.8rem;padding:0 0 1.7rem;border-bottom:1px solid rgba(var(--color-foreground),.14)}
      .ops-library__visual-archive-head{display:flex;align-items:baseline;justify-content:space-between;gap:1.5rem;margin:0 0 1rem;padding-top:.15rem}
      .ops-library__visual-archive-title{display:flex;align-items:baseline;gap:.7rem;flex-wrap:wrap}
      .ops-library__visual-archive-title .ops-library__eyebrow{margin:0}
      .ops-library__visual-archive-title span{font-size:.73rem;letter-spacing:.08em;text-transform:uppercase;color:rgba(var(--color-foreground),.48)}
      .ops-library__visual-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:1.65rem 1.15rem;align-items:start}
      .ops-library__visual-card{margin:0;min-width:0}
      .ops-library__visual-image{display:flex;align-items:center;justify-content:center;width:100%;min-height:285px;aspect-ratio:4/3;padding:.8rem;background:rgba(var(--color-foreground),.025);overflow:hidden;text-decoration:none}
      .ops-library__visual-image img{display:block;width:100%;height:100%;object-fit:contain;transition:transform .2s ease}
      .ops-library__visual-image:hover img{transform:scale(1.012)}
      .ops-library__visual-caption{padding:.72rem .08rem 0}
      .ops-library__visual-date{margin:0 0 .25rem;font-size:.72rem;line-height:1.25;letter-spacing:.075em;text-transform:uppercase;color:rgba(var(--color-foreground),.55)}
      .ops-library__visual-caption h4{margin:0;font-size:1rem;line-height:1.3;font-weight:650}
      .ops-library__visual-credit{margin:.28rem 0 0;font-size:.82rem;line-height:1.42;color:rgba(var(--color-foreground),.68)}
      .ops-library__visual-medium{margin:.44rem 0 0;font-size:.8rem;line-height:1.4;color:rgba(var(--color-foreground),.82)}
      .ops-library__visual-character{margin:.58rem 0 0;font-size:.82rem;line-height:1.48;color:rgba(var(--color-foreground),.7)}
      .ops-library__visual-record{margin-top:.62rem;padding-top:.52rem;border-top:1px solid rgba(var(--color-foreground),.095)}
      .ops-library__visual-record summary{cursor:pointer;width:max-content;max-width:100%;font-size:.71rem;font-weight:650;letter-spacing:.055em;text-transform:uppercase;color:rgba(var(--color-foreground),.66)}
      .ops-library__visual-record summary:hover{color:rgb(var(--color-foreground))}
      .ops-library__visual-record dl{display:grid;gap:.5rem;margin:.7rem 0 0}
      .ops-library__visual-record dt{font-size:.64rem;letter-spacing:.07em;text-transform:uppercase;color:rgba(var(--color-foreground),.46)}
      .ops-library__visual-record dd{margin:.06rem 0 0;font-size:.77rem;line-height:1.42;color:rgba(var(--color-foreground),.76);overflow-wrap:anywhere}
      .ops-library__visual-record a{color:inherit;text-underline-offset:.18em}
      .ops-library__visual-source-link{display:inline-block;margin-top:.58rem;font-size:.76rem;font-weight:650;text-underline-offset:.2em}
      @media(min-width:1100px){
        .ops-library__visual-grid{grid-template-columns:repeat(3,minmax(0,1fr))}
        .ops-library__visual-image{min-height:320px}
      }
      @media(max-width:749px){
        .ops-library__visual-archive{margin-top:0;padding-bottom:1.25rem}
        .ops-library__visual-archive-head{margin-bottom:.75rem}
        .ops-library__visual-grid{display:flex;gap:.9rem;overflow-x:auto;scroll-snap-type:x mandatory;padding:0 1rem .5rem 0;margin-right:-1rem;overscroll-behavior-inline:contain}
        .ops-library__visual-card{flex:0 0 min(84vw,360px);scroll-snap-align:start}
        .ops-library__visual-image{min-height:0;aspect-ratio:4/3;padding:.55rem}
        .ops-library__visual-caption{padding-top:.6rem}
      }
    `;
    document.head.appendChild(style);
  };

  const conciseMedium=(source)=>{
    const parts=[];
    const medium=source.medium||'';
    const technique=source.technique||source.process||'';
    if(medium) parts.push(medium);
    if(technique && key(technique)!==key(medium)) parts.push(technique);
    return parts.join(' · ');
  };

  const recordRows=(source)=>[
    ['Period',source.period],
    ['Page / folio / plate',source.page||source.folio||source.plate],
    ['Institution',source.institution],
    ['Collection',source.collection],
    ['Material / support',source.material||source.materials||source.support],
    ['Dimensions',source.dimensions],
    ['Colour',source.colour||source.color],
    ['Rights / licence',source.rights],
    ['Attribution',source.attribution],
    ['Catalogue note',source.note]
  ].filter(([,value])=>value);

  const card=(source,index)=>{
    const title=source.work||source.title||'Historical visual source';
    const creator=source.creator||'Creator not recorded';
    const institution=source.institution||source.collection||'';
    const image=source.imageUrl||source.image||'';
    const sourceUrl=source.sourceUrl||source.url||'';
    const medium=conciseMedium(source);
    const visual=source.visualCharacter||source.visual||'';
    const records=recordRows(source);
    const date=source.date||source.period||'Date not recorded';
    return `<figure class="ops-library__visual-card">
      ${image?`<a class="ops-library__visual-image" href="${esc(sourceUrl||image)}" target="_blank" rel="noopener noreferrer" aria-label="Open source record for ${esc(title)}"><img src="${esc(image)}" alt="${esc(title)}" ${index===0?'loading="eager" fetchpriority="high"':'loading="lazy"'}></a>`:''}
      <figcaption class="ops-library__visual-caption">
        <p class="ops-library__visual-date">${esc(date)}</p>
        <h4>${esc(title)}</h4>
        <p class="ops-library__visual-credit">${esc(creator)}${institution?` · ${esc(institution)}`:''}</p>
        ${medium?`<p class="ops-library__visual-medium">${esc(medium)}</p>`:''}
        ${visual?`<p class="ops-library__visual-character">${esc(visual)}</p>`:''}
        ${records.length?`<details class="ops-library__visual-record"><summary>Catalogue record</summary><dl>${records.map(([label,value])=>`<div><dt>${esc(label)}</dt><dd>${esc(value)}</dd></div>`).join('')}${source.rightsUrl?`<div><dt>Licence</dt><dd><a href="${esc(source.rightsUrl)}" target="_blank" rel="noopener noreferrer">Open licence record ↗</a></dd></div>`:''}</dl></details>`:''}
        ${sourceUrl?`<a class="ops-library__visual-source-link" href="${esc(sourceUrl)}" target="_blank" rel="noopener noreferrer">Source ↗</a>`:''}
      </figcaption>
    </figure>`;
  };

  const mount=()=>{
    const article=document.querySelector('[data-library-article] .ops-library__article--editorial');
    if(!article) return;
    const title=article.querySelector('.ops-library__entry-hero h2')?.textContent?.trim();
    if(!title) return;
    const pack=window.OPS_OCCULT_EDITORIAL;
    const entry=pack?.entries?.find((item)=>key(item?.title)===key(title));
    const sources=Array.isArray(entry?.visualSources)?entry.visualSources.filter((source)=>source&&(source.imageUrl||source.image)):[];
    const existing=article.querySelector('.ops-library__visual-archive');
    if(!sources.length){
      existing?.remove();
      article.classList.remove('has-visual-archive');
      return;
    }
    article.classList.add('has-visual-archive');
    const signature=`${key(title)}:${sources.length}:${sources.map((s)=>s.sourceUrl||s.imageUrl||'').join('|')}`;
    if(existing?.dataset.signature===signature) return;
    existing?.remove();
    const section=document.createElement('section');
    section.className='ops-library__visual-archive';
    section.dataset.visualArchive='';
    section.dataset.signature=signature;
    section.setAttribute('aria-label',`Historical visual sources for ${title}`);
    section.innerHTML=`<header class="ops-library__visual-archive-head"><div class="ops-library__visual-archive-title"><p class="ops-library__eyebrow">VISUAL ARCHIVE</p><span>${sources.length} historical ${sources.length===1?'source':'sources'}</span></div></header><div class="ops-library__visual-grid">${sources.map(card).join('')}</div>`;
    const hero=article.querySelector('.ops-library__entry-hero');
    hero?.insertAdjacentElement('afterend',section);
  };

  const boot=()=>{
    installStyles();
    const target=document.querySelector('[data-library-article]');
    if(!target) return;
    new MutationObserver(()=>requestAnimationFrame(mount)).observe(target,{childList:true,subtree:true});
    mount();
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();
